import { createFileRoute, redirect } from '@tanstack/react-router';

/*
 * Open an organization on its PROFILE by default (E02.F09 — R119 AC-ed6c6153).
 * Bare `/entities/:id` redirects to the first section — the profile — which is
 * every kind's first composed section (lib/entity-composition). An address that
 * names an organization but no section therefore lands on the profile
 * (AC-e3e45d1d), the same way. The sectioned view lives in `$entityId/$section`.
 *
 * The redirect is a `beforeLoad` throw (runs outside React), so no part of a
 * section renders before the profile is chosen.
 */
export const Route = createFileRoute('/_auth/entities/$entityId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/entities/$entityId/$section',
      params: { entityId: params.entityId, section: 'profile' },
      replace: true,
    });
  },
});
